"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import { RegionalPageApartmentCount } from "./RegionalPageApartmentCount";
import { RegionalPageRichText } from "./RegionalPageRichText";

export function ExploreDescription({
  copyTopRichText = "",
  numberOfApartmentsText = "# Apartments in Market",
}) {
  return (
    <Block
      className={"explore_left"}
      id={"w-node-e29151de-eca2-8cbe-6ad2-dda610c0f532-10c0f532"}
      tag={"div"}
    >
      <Block className={"div-block-57"} tag={"div"}>
        <Block className={"div-block-64"} tag={"div"}>
          <Block className={"decoration-line is-small"} tag={"div"} />
        </Block>
        <RegionalPageRichText copyTopRichText={copyTopRichText} />
        <RegionalPageApartmentCount
          numberOfApartmentsText={numberOfApartmentsText}
        />
      </Block>
    </Block>
  );
}
